@import "~/styles/variables";

/*
 * NOTE:
 * These need fully reset styles for now thanks to our global v1 styles
 */

// Reset for <label>
.Label {
  color: initial;
  display: inline;
  font-size: initial;
  font-weight: 400;
  margin-bottom: 0;
  max-width: none;
  text-align: start;
}

$label-vertical-stack: "xxs";
// This is to balance the vertical spacing between blocks, due to line heights
$label-vertical-offset: -3px;

.Label,
.Required {
  @include font-size("s");
}

.Label {
  display: block;
  @include font-weight("semibold");

  &_stacked {
    @include stack($label-vertical-stack);
  }
}

.Required {
  @include font-color("light");
  @include font-weight("semibold");
  font-style: italic;

  &_stacked {
    @include stack($label-vertical-stack);
    // This is to balance the vertical spacing between label & desc
    margin-top: $label-vertical-offset;
  }
}

.Description {
  @include font-color("light");
  @include font-size("s");
  @include font-weight("semibold");
  // This is to balance the vertical spacing when both a label & desc are shown
  margin-top: $label-vertical-offset;
}

.Wrapper {
  &_right {
    text-align: right;

    .Title {
      justify-content: flex-end;
    }

    .Label {
      text-align: right;
    }
  }

  &_m {
    .Label,
    .Required {
      @include font-size("m");
    }
  }

  &_compact {
    .Label,
    .Required {
      @include font-size("xxs");
    }

    .Label {
      @include font-color("light");
      @include font-weight("bold");
      text-transform: uppercase;
    }

    &.Wrapper_m {
      .Label,
      .Required {
        @include font-size("s");
      }
    }
  }

  &_horizontal {
    .Title,
    .Description {
      @include stack("xs");
    }

    .Title {
      display: flex;
    }
  }
}
